import styled from "livemap-ui";

export const Copyright = () => (
  <Container>
    <svg viewBox="0 0 10 10" width="30" height="30">
      <path d="M5 0 l 2 4 -2 4 -2 -4z M2 6 l 2 4 -4 0z M8 6 l 2 4 -4 0z" />
    </svg>
    <WatermarkText>Veridict</WatermarkText>
    <WatermarkCopy>&copy; {new Date().getUTCFullYear()}</WatermarkCopy>
  </Container>
);

const WatermarkText = styled.p`
  text-align: center;
  text-transform: uppercase;
  font-family: ${p => p.theme.headingFontFamily};
  font-weight: 700;
  line-height: 0.8;
  padding-top: 8px;
  font-size: 14px;
`;

const WatermarkCopy = styled(WatermarkText)`
  padding-top: 4px;
  font-size: 12px;
  font-weight: 500;
  margin-left: -6px;
`;

const Container = styled.div`
  opacity: ${p => p.theme.dimOpacity};
  display: flex;
  align-items: center;
  flex-direction: column;
  user-select: none;

  > svg {
    width: 24px;
    height: 24px;
  }
`;
